import { render } from "./LeftSidebar.vue?vue&type=template&id=cc67db72&scoped=true"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"

import "./LeftSidebar.vue?vue&type=style&index=0&id=cc67db72&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc67db72"]])

export default __exports__